export default __webpack_public_path__ + "static/media/closet5-before1-1024w.6023428a.avif";